import React, { useState } from "react";

function Accordion({ accordionKey, content, title, theme = "light" }) {
  const [open, setOpen] = useState(false);
  const accordionTag =
    theme === "light" ? "accordion" : theme === "dark" && "accordion-dark";
  const handleOpen = () => {
    // document.getElementById(
    //   "accordion__tournament-" + accordionKey
    // ).style.visibility = "visible";
    // document.getElementById(
    //   "accordion__tournament-" + accordionKey
    // ).style.height = "100%";
    // document.getElementById("accordion-" + accordionKey).style.height = "100%";
    setOpen(true);
  };

  const handleClose = () => {
    // document.getElementById(
    //   "accordion__tournament-" + accordionKey
    // ).style.visibility = "collapse";
    // document.getElementById(
    //   "accordion__tournament-" + accordionKey
    // ).style.height = "0px";
    // document.getElementById("accordion-" + accordionKey).style.height = "84px";
    setOpen(false);
  };

  const handleArrowIcon = () => {
    return theme === "light" && open
      ? "/close_arrow.png"
      : theme === "light" && !open
      ? "/expand_arrow.png"
      : theme === "dark" && open
      ? "/close_arrow_white.png"
      : theme === "dark" && !open && "/expand_arrow_white.png";
  };

  return (
    <div className={accordionTag} id={"accordion-" + accordionKey}>
      <div className="accordion__bar">
        <h2 className={`${accordionTag}__title`}>{title}</h2>
        <button
          className={`${accordionTag}__expandBtn`}
          onClick={open ? handleClose : handleOpen}
        >
          <img id="accordion__expandIcon" src={handleArrowIcon()} alt="" />
        </button>
      </div>
      <ul
        className={`${accordionTag}__content${open ? "-open" : ""}`}
        id={"accordion__content-" + accordionKey}
      >
        {content &&
          content.map((chp) => {
            return chp;
          })}
      </ul>
    </div>
  );
}

export default Accordion;
